import { createContext } from "react";


export interface IAudioContext {
    play?: () => void;
    pause?: () => void;
    setVolume?: (v: number) => void;
    setSrc?: (src: string) => void;
    setVisible?: (visible: boolean) => void;
}

export const AudioContextDefaults: IAudioContext = {

}

export const AudioContext = createContext<IAudioContext>({});